
const digest = '5243c5011155bc2dcc921daa67d377d6bf6967da3d2c459c4cffaa24d2ea3df2';
const classes = {"wrapper":"_wrapper_1nwyv_1"};
const css = `._wrapper_1nwyv_1 {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  background: #ffffff;
}
._wrapper_1nwyv_1::-webkit-scrollbar {
  display: block;
}
._wrapper_1nwyv_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1nwyv_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1nwyv_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1nwyv_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  